import React from "react"

import "./styles.css"
import SkillLevelInfo from "../../molecules/SkillLevelInfo"
import LevelNavigatorComponent from "../../organisms/LevelNavigator"

const SkillInfoContainer = (props) => {
	const {
		skill,
		index,
		cooldown,
		skillLevel,
		handleClickInfoNavigator
	} = props
	const displayLevel = skill.levelsInfo[index]
	const isBaseSkill = skill.levelsInfo[0].necessaryLevel === 1
	return (
		<div className="skill-description">
			<h1>{skill.name}</h1>
			<span>Nível mínimo necessário: {displayLevel.necessaryLevel}</span>
			{skillLevel > 0 || isBaseSkill ? (
				<SkillLevelInfo
					indexLevel={index}
					maxLevel={skill.levelsInfo.length}
					displayLevel={displayLevel}
					characterCooldown={cooldown}
				/>
			) : (
					<div className="level-container">
						<span id="noInfo">
							Essa habilidade ainda não foi obtida. Clique em "Próximo
							Level" ou aprimore a habilidade para visualizar as
							informações.
                    </span>
					</div>
				)}
			<LevelNavigatorComponent
				skillLevel={skillLevel}
				maxLevel={skill.levelsInfo.length}
				isBaseSkill={isBaseSkill}
				handleClickInfoNavigator={handleClickInfoNavigator}
			/>
		</div>
	)
}

export default React.memo(SkillInfoContainer)
